'use strict';

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

NavigationButtonDirective=class NavigationButtonDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/navigationButtonDirective/navigationButtonTemplate'}

get textBindings(){return['destinationState','label','tfmLabel','wfmLabel','wfmaLabel','afmLabel']}

get controller(){return NavigationButtonDirectiveController}

get $inject(){return['$scope','breadcrumbsService','userService']}};let


NavigationButtonDirectiveController=class NavigationButtonDirectiveController{
constructor($scope,breadcrumbsService,userService){
this._$scope=$scope;
this._breadcrumbsService=breadcrumbsService;
this._userService=userService;

if(this.label&&_.exists(this.tfmLabel||this.wfmLabel||this.wfmaLabel||this.afmLabel)){
throw new Error('Cannot provide industry-specific labels when generic label is provided.');
}

const fatigueMeterType=_.get(this._userService,'currentUser.fatigueMeterType');

switch(fatigueMeterType){
case FatigueMeterType.Trucking:
this.label=this.tfmLabel;
break;
case FatigueMeterType.WorkforceAviation:
this.label=this.wfmaLabel||this.wfmLabel;
break;
case FatigueMeterType.Workforce:
this.label=this.wfmLabel;
break;
case FatigueMeterType.Aviation:
this.label=this.afmLabel;
break;
default:
throw new Error(`Invalid FatigueMeterType found, unable to determine correct NavigationButonDirective label. Got: ${fatigueMeterType}`);}


this._refresh();
this._$scope.$watchCollection('controller._breadcrumbsService.crumbs',()=>this._refresh());
}

_refresh(){
this._inDestinationStateOrSubState=_(this._breadcrumbsService.crumbs).some(c=>c.stateName===this.destinationState);
}

get inDestinationStateOrSubState(){
return this._inDestinationStateOrSubState;
}};



module.exports=NavigationButtonDirective;
//# sourceMappingURL=navigationButtonDirective.js.map
